<template>
  <AppLayout>
    <div class="container mt-4">
      <div class="col-12 row d-flex align-items-stretch">

        <div class="col-md-12 col-lg-10 d-flex align-items-stretch">
          <div class="mb-3 me-3 col-auto d-flex align-items-center">
            <Link :href="route('bhp.terminy.lista')" class="btn btn-outline-primary">
              <i class="bi bi-list"></i>&nbsp;Powrót do listy
            </Link>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body d-flex flex-column justify-content-start">
              <h5 class="card-title w-100 d-flex justify-content-between align-items-center">
                <span>Dane pracownika</span>
              </h5>
              <div class="row">
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneImie">Imię:</label>
                  <div style="border-radius: 0;" id="lokalneImie" class="form-control">{{ lokalneImie }}</div>
                </div>
                <div class="col-md-6 col-lg-6 mb-3">
                  <label class="form-label" for="lokalneNazwisko">Nazwisko:</label>
                  <div style="border-radius: 0;" id="lokalneNazwisko" class="form-control">{{ lokalneNazwisko }}</div>
                </div>
                <div class="col-md-4 col-lg-4 mb-3">
                  <label class="form-label" for="lokalneTelFir">Telefon firmowy:</label>
                  <div style="border-radius: 0;" id="lokalneTelFir" class="form-control">{{ lokalneTelFir }}</div>
                </div>
                <div class="col-md-4 col-lg-4 mb-3">
                  <label class="form-label" for="lokalneEmFir">E-mail firmowy:</label>
                  <div style="border-radius: 0;" id="lokalneEmFir" class="form-control">{{ lokalneEmFir }}</div>
                </div>
                <div class="col-md-4 col-lg-4 mb-3">
                  <label class="form-label" for="oddzial">Oddział:</label>
                  <select class="form-control" style="border-radius: 0;" @mousedown.prevent>
                    <option>{{ oddzial }}</option>
                  </select>
                </div>
                <div class="col-md-12 col-lg-12 mb-3">
                  <label class="form-label" for="lokalnestanowisko">Stanowisko:</label>
                  <div style="border-radius: 0;" id="lokalnestanowisko" class="form-control">{{
                      lokalnestanowisko
                    }}
                  </div>
                </div>
                <div class="col-md-12 col-lg-12 mb-3">
                  <label class="form-label" for="dzial">Dział:</label>
                  <select class="form-control" style="border-radius: 0;" @mousedown.prevent>
                    <option>{{ departament_name }}</option>
                  </select>
                </div>


              </div>
            </div>
          </div>
        </div>


        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <div class="h-100">
                <h5 class="card-title">Terminy pracownika</h5>
                <button v-if="hasPermission('canEditBHP')" @click="openModalAddTermin"
                        class="btn btn-success btn-sm mb-2">
                  <i class="bi bi-plus-circle me-2"></i>Dodaj termin
                </button>

                <div v-if="lokalneTerminyUser.length || dodajTermin" class="table-responsive mb-2">
                  <table class="table table-bordered table-hover">
                    <thead>
                    <tr class="text-center">
                      <th>Rodzaj</th>
                      <th>Wykonano</th>
                      <th>Ważność do</th>
                      <th>Przypomnienie (dni)</th>
                      <th>Opcje</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(termin, index) in lokalneTerminyUser" :key="termin.id">
                      <td style="min-width: 150px;">
                        <div class="d-flex justify-content-between align-items-center">
                          {{ termin.termin?.nazwa || '' }}
                          <span v-if="showWarning(termin.data_end, termin.ile_wczesniej)" class="text-warning"
                                title="Termin kończy się w mniej niż 30 dni">⚠️</span>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                        <span v-if="(termin.stanowisko || '').toLowerCase() !== (lokalnestanowisko || '').toLowerCase()">
  {{ termin.stanowisko || '' }}
</span>
                          <span
                              v-if="(termin.stanowisko || '').toLowerCase() !== (lokalnestanowisko || '').toLowerCase() && termin.termin?.check_position == 1"
                              class="text-warning" title="Stanowiska różnią się dla terminu pracownika!">⚠️</span>
                        </div>

                      </td>
                      <td class="text-center">
                        <span class="text-center">{{
                            termin.data_make ? new Date(termin.data_make).toLocaleDateString() : ''
                          }}</span>
                      </td>
                      <td v-if="isExpired(termin.data_end)" class="bg-danger text-white text-center">
                        <span class="text-center">{{
                            termin.data_end ? new Date(termin.data_end).toLocaleDateString() : ''
                          }}</span>
                      </td>
                      <td v-else class="text-center">
                        <span>{{ termin.data_end ? new Date(termin.data_end).toLocaleDateString() : '' }}</span>
                      </td>
                      <td class="text-center">
                        <span>{{ termin.ile_wczesniej }}</span>
                      </td>
                      <td style="max-width: 100px;" class="text-center">
                        <button v-if="hasPermission('canEditBHP') && (termin.termin?.jaki_dzial == 2 || termin.termin?.jaki_dzial == 0)"
                                @click="openModalEditTermin(termin)"
                                class="btn btn-sm btn-outline-warning me-2 mb-2"
                        >
                          <i class="bi bi-pencil me-2"></i>Edytuj
                        </button>
                        <button v-if="hasPermission('canDelDataBHP') &&  (termin.termin?.jaki_dzial == 2 || termin.termin?.jaki_dzial == 0)"
                                @click="deleteTermin(termin.id)" class="btn btn-sm btn-danger">
                          <i class="bi bi-trash me-2"></i>Usuń
                        </button>
                      </td>
                    </tr>
                    </tbody>

                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6 mb-4">
          <div class="card h-100 shadow-sm">
            <div class="card-body">
              <div class="h-100">
                <h5 class="card-title">Pliki</h5>

                <div class="row">
                  <ul class="list-group ps-3 me-3 mt-3 mb-3">
                    <li
                        class="list-group-item d-flex align-items-center justify-content-between flex-wrap fw-bold bg-light"
                        v-if="localFiles.length > 0"
                    >
                      <div class="col-12 col-sm-6 col-md-5 text-truncate">Nazwa pliku</div>
                      <div class="col-12 col-sm-4 col-md-4">Data utworzenia</div>
                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">Opcje</div>
                    </li>

                    <!-- Loader -->
                    <li v-if="isLoadingFiles" class="list-group-item border-0">
                      <div class="spinner-border spinner-border-reverse align-self-center loader-sm text-secondary">
                        Ładowanie...
                      </div>
                    </li>

                    <!-- Lista plików -->
                    <li class="list-group-item d-flex align-items-center justify-content-between flex-wrap" v-else
                        v-for="file in localFiles" :key="file.id">
                      <!-- Nazwa pliku -->
                      <div class="col-12 col-sm-6 col-md-5 text-truncate" :title="file.name">
                        {{ file.name }}
                      </div>

                      <!-- Data utworzenia -->
                      <div class="col-12 col-sm-4 col-md-4 text-muted small">
                        <i>{{ file.created_at }}</i>
                      </div>

                      <!-- Opcje -->
                      <div class="col-12 col-sm-2 col-md-3 text-end mt-2 mt-sm-0">
                        <div class="d-flex justify-content-end flex-wrap gap-1">
                          <a class="btn btn-sm btn-outline-info" style="width:80px;"
                             :href="route('bhp.download-file', [this.userID, file.name])"
                             download>
                            <i class="bi bi-download me-1"></i>Pobierz
                          </a>
                          <button v-if="hasPermission('canDelDataBHP')"
                                  class="btn btn-sm btn-outline-danger" style="width:80px;"
                                  @click="deleteFile(file)"
                                  type="button">
                            <i class="bi bi-trash me-1"></i>Usuń
                          </button>
                        </div>
                      </div>
                    </li>

                    <!-- Brak plików -->
                    <li class="list-group-item" v-if="localFiles.length <= 0 && !isLoadingFiles">
                      <i>Brak plików</i>
                    </li>
                  </ul>
                </div>

                <form @submit.prevent="submitForm">
                  <div class="row gap-3">
                    <div class="col-12">
                      <label for="attachments">Dodaj pliki:</label>
                      <div v-if="isLoading" class="mt-3">
                        <div class="progress" style="height: 8px;">
                          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
                               :style="{ width: uploadProgress + '%' }"></div>
                        </div>
                        <small class="text-muted">{{ uploadProgress }}%</small>
                      </div>
                      <input type="file" id="attachments" multiple @change="handleFileUpload"
                             class="form-control form-control-sm" ref="fileInput"/>
                      <div v-if="form.attachments.length">
                        <p class="mt-2">Załączone pliki:</p>
                        <ul class="list-group">
                          <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap"
                              v-for="(file, index) in form.attachments" :key="index">
                            <span class="text-truncate" :title="file.name">{{ file.name }}</span>
                            <button type="button" class="btn btn-sm btn-danger ms-2 mt-1 mt-sm-0"
                                    @click="removeFile(index)">Usuń
                            </button>
                          </li>
                        </ul>
                      </div>
                      <div v-if="form.attachments.length">
                        <button type="submit" class="btn btn-primary mt-3" :disabled="isLoading">
                          {{ isLoading ? 'Wysyłanie...' : 'Dodaj pliki' }}
                        </button>
                      </div>

                    </div>
                  </div>
                </form>

              </div>
            </div>
          </div>
        </div>

        <div v-if="isModalOpenAddTermin" class="modal fade show" tabindex="-1" style="display: block;">
          <div class="modal-dialog modal-lg">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ editingTermin ? 'Edytuj termin' : 'Dodaj nowy termin' }}
                </h5>
                <button type="button" class="btn-close" @click="closeModalAddTermin"></button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <!-- tylko przy dodawaniu -->
                  <div v-if="!editingTermin" class="col-md-12">
                    <label class="form-label" for="termin">Wybierz rodzaj terminu:</label>
                    <select id="termin" v-model="newTermin.termin_id" @change="setDefaultIleWczesniej()"
                            class="form-control">
                      <option disabled value="">-- Wybierz termin --</option>
                      <option v-for="t in lokalneTerminy" :key="t.id" :value="t.id">{{ t.nazwa }}</option>
                    </select>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label" for="datamake">Data wykonania:</label>
                    <input id="datamake" v-model="newTermin.data_make" class="form-control" type="date"/>
                  </div>

                  <!-- przy dodawaniu: wybór ważności -->
                  <div v-if="!editingTermin" class="col-md-4">
                    <label class="form-label" for="waznosc">Ważność:</label>
                    <select id="waznosc" v-model="newTermin.data_end" class="form-control">
                      <option value="">-- wybierz --</option>
                      <option value="bezterminowo">Bezterminowo</option>
					  <option :value="0.5">6 miesięcy</option>
                      <option v-for="year in 10" :key="year" :value="year">
                        {{ year }} {{ year === 1 ? 'rok' : (year >= 2 && year <= 4 ? 'lata' : 'lat') }}
                      </option>
                    </select>
                  </div>

                  <!-- przy edycji: bez selecta, tylko data -->
                  <div v-else class="col-md-4">
                    <label class="form-label" for="dataend">Ważne do:</label>
                    <input id="dataend" v-model="newTermin.data_end" class="form-control" type="date"/>
                  </div>

                  <div class="col-md-4">
                    <label class="form-label" for="ile">Ile dni wcześniej przypomnieć:</label>
                    <input id="ile" v-model.number="newTermin.ile_wczesniej" class="form-control" type="number"
                           min="0"/>
                  </div>

                  <div class="col-md-12">
                    <label class="form-label" for="termin_stanowisko">Termin na stanowisko:</label>
                    <input id="termin_stanowisko" v-model="newTermin.stanowisko" class="form-control" type="text"/>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" @click="closeModalAddTermin">Anuluj</button>
                <button v-if="!editingTermin" class="btn btn-primary" @click="saveNewTermin">Dodaj termin</button>
                <button v-else class="btn btn-success" @click="updateTerminModal">Zapisz zmiany</button>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import {DateRangePickerComponent} from "@syncfusion/ej2-vue-calendars";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import {Tooltip} from 'bootstrap';
import {isDisabled} from "bootstrap/js/src/util/index.js";
import route from "../../../../vendor/tightenco/ziggy/src/js/index.js";
import {router} from "@inertiajs/vue3";


const {hasPermission} = usePermission();

export default {
  props: {
    userData: Object,
    userDane: Object,
    userImie: String,
    userNazwisko: String,
    departament: String,
    userID: Number,
    oddzial: String,
    departament_name: String,
    userPhoneFir: String,
    userEmailFir: String,
    newTermin: {
      termin_id: '',
      data_make: '',
      data_end: '',
      ile_wczesniej: null,
    },
    terminy: {
      type: Array,
      default: () => []
    },
    terminyUser: {
      type: Array,
      default: () => []
    },
    pliki: {
      type: Array,
      required: true,
      default: () => []
    }
  },


  components: {AppLayout, 'ejs-daterangepicker': DateRangePickerComponent, hasPermission},
  data() {
    const now = new Date();

    const today = new Date();
    return {
      initAttachments: [],
      form: {
        name: null,
        attachments: [],
        errors: {}
      },
      addingNew: false,
      localFiles: [...this.pliki],
      lokalneTerminy: [...this.terminy],
      lokalneTerminyUser: [...this.terminyUser],
      lokalneImie: this.userImie ?? '',
      lokalneNazwisko: this.userNazwisko ?? '',
      lokalnestanowisko: this.departament ?? '',
      lokalneTelFir: this.userPhoneFir ?? '',
      lokalneEmFir: this.userEmailFir ?? '',
      isLoadingFiles: true,
      isLoading: false,
      isProcessing: false,
      editingDate: null,
      editedDate: '',
      editedDateMake: '',
      editedDateEnd: '',
      uploadProgress: 0,
      uploadError: null,
      uploadSuccess: false,
      formError: false,
      isModalOpenAddTermin: false,
      editingTermin: null, // <- dodane: przechowuje termin w trybie edycji
      newTermin: {
        termin_id: '',
        data_make: '',
        data_end: '',
        ile_wczesniej: null,
        stanowisko: this.departament ?? '',
      },
      ileWczesniejOptions: [
        {value: null, label: 'Bezterminowo'},
        {value: 1, label: '1 rok'},
        {value: 2, label: '2 lata'},
        {value: 3, label: '3 lata'},
        {value: 4, label: '4 lata'},
        {value: 5, label: '5 lat'},
        {value: 6, label: '6 lat'},
        {value: 7, label: '7 lat'},
        {value: 8, label: '8 lat'},
        {value: 9, label: '9 lat'},
        {value: 10, label: '10 lat'},
      ],

      editedIleWczesniej: null,
      hasPermission
    };
  },

async mounted() {
  console.log('=== START DEBUG ===');
  console.log('userID:', this.userID);
  console.log('props.userData:', this.userData);
  console.log('props.userDane:', this.userDane);
  console.log('props.terminyUser:', this.terminyUser);
  console.log('props.pliki:', this.pliki);
  console.log('departament:', this.departament);
  console.log('oddzial:', this.oddzial);

  this.fetchTerminy();

  this.initAttachments = await this.getAttachments();
  console.log('attachments:', this.initAttachments);

  this.matchFiles();
  this.isLoadingFiles = false;

  console.log('=== END DEBUG ===');
},

  methods: {
    async deleteFile(file) {
      let self = this;

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie pliku',
        html: 'Czy na pewno chcesz usunąć ten plik?',
        showDenyButton: true,
        timer: false,
        position: 'center',
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.delete(route('bhp.file.delete', {
              user_id: self.userID,
              attachment: file.id
            }));

            if (response.data.icon === 'success') {
              self.showToast('success', 'Usunięto plik', 'Plik został pomyślnie usunięty.');
              await self.refreshAttachments(); // odśwież listę plików
            } else {
              self.showToast('error', response.data.title, response.data.message);
            }

          } catch (error) {
            console.error("Błąd usuwania pliku:", error);
            self.showToast('error', 'Błąd', 'Nie udało się usunąć pliku.');
          }
        }
      });
    },


    async getAttachments() {
      const user_id = this.userID;
      try {
        const response = await axios.post(route('bhp.get.userfiles', {user_id: user_id}));
        return response.data.attachments ?? [];
      } catch (error) {
        console.log(error);
        return [];
      }
    },

    handleFileUpload(event) {
      this.uploadError = null;
      const files = Array.from(event.target.files);

      const maxSize = 100 * 1024 * 1024; // 100 MB
      const validFiles = [];

      for (let file of files) {
        if (file.size > maxSize) {
          this.uploadError = `Plik "${file.name}" jest za duży (max 100 MB).`;
        } else if (file.size === 0) {
          this.uploadError = `Plik "${file.name}" jest pusty.`;
        } else {
          validFiles.push(file);
        }
      }

      if (validFiles.length > 0) {
        this.form.attachments.push(...validFiles);
      }

      this.$refs.fileInput.value = "";
    },

    removeFile(index) {
      this.form.attachments.splice(index, 1);
    },

    matchFiles() {
      try {
        if (this.initAttachments.length > 0) {
          this.localFiles = [...this.initAttachments];
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },

    async refreshAttachments() {
      this.isLoadingFiles = true;
      try {
        const attachments = await this.getAttachments();
        this.localFiles = attachments;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingFiles = false;
      }
    },

    async submitForm() {
      this.form.errors = {};
      this.uploadError = null;
      this.uploadProgress = 0;
      this.isProcessing = true;

      if (this.form.attachments.length === 0) {
        this.uploadError = "Nie wybrano plików do wysłania.";
        this.isProcessing = false;
        return;
      }

      this.isLoading = true;
      let formData = new FormData();
      this.form.attachments.forEach((file) => {
        formData.append('attachments[]', file);
      });

      const user_id = this.userID;

      try {
        const response = await axios.post(route('bhp.add.file', {user_id}), formData, {
          headers: {'Content-Type': 'multipart/form-data'},
          onUploadProgress: (progressEvent) => {
            if (progressEvent.total) {
              this.uploadProgress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            }
          }
        });

        // po sukcesie
        this.form.attachments = [];
        await this.refreshAttachments();
        this.$refs.fileInput.value = "";
        this.uploadProgress = 100;

      } catch (error) {
        console.error("Błąd zapisu:", error);
        this.uploadError = error.response?.data?.message || "Wystąpił błąd podczas wysyłania pliku.";
      } finally {
        this.isProcessing = false;
        this.isLoading = false;

        setTimeout(() => this.uploadProgress = 0, 3000);
      }
    },

    openModalAddTermin() {
      this.editingTermin = null; // reset
      this.newTermin = this.getEmptyFormTerminy();
      this.isModalOpenAddTermin = true;
    },

    openModalEditTermin(termin) {
      this.editingTermin = termin.id;
      this.newTermin = {
        termin_id: termin.termin_id,
        data_make: termin.data_make ? termin.data_make.split('T')[0] : '',
        data_end: termin.data_end ? termin.data_end.split('T')[0] : '',
        ile_wczesniej: termin.ile_wczesniej,
        stanowisko: termin.stanowisko,
      };
      this.isModalOpenAddTermin = true;
    },

    async updateTerminModal() {
      const user_id = this.userID;
      try {
        await axios.put(route('bhp.update.termin', user_id), {
          termin_id: this.editingTermin,
          newMake: this.newTermin.data_make,
          newEnd: this.newTermin.data_end,
          ile_wczesniej: this.newTermin.ile_wczesniej,
          stanowisko: this.newTermin.stanowisko,
        });
        this.showToast('success', 'Zapisano', 'Termin został zaktualizowany.');
        this.isModalOpenAddTermin = false;
        this.fetchTerminy();
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się zaktualizować terminu.');
      }
    },

    isExpired(data_end) {
      console.log('data_end:', data_end);
      if (!data_end) return false;

      const today = new Date();
      const DateEnd = (data_end instanceof Date) ? data_end : new Date(data_end);
      console.log('DateEnd:', DateEnd);
      if (isNaN(DateEnd)) return false;

      const roznica = (DateEnd - today) / (1000 * 60 * 60 * 24);
      console.log('roznica', roznica);
      return roznica < 0;
    },

    showWarning(data_do, days) {
      if (!data_do) return false;
      if (!days) return false;

      const today = new Date();
      const DateDo = (data_do instanceof Date) ? data_do : new Date(data_do);

      if (isNaN(DateDo)) {
        return false;
      }

      const kiedy = DateDo - today;
      const zostalo_dni = kiedy / (1000 * 60 * 60 * 24);

      return zostalo_dni < days;
    },

    closeModalAddTermin() {
      this.isModalOpenAddTermin = false;
      this.getEmptyFormTerminy();
    },


    getEmptyForm() {
      return {
        data: '' // wystarczy tylko data, jeśli nie masz ID po stronie backendu
      };
    },

    async saveNewTermin() {
      if (!this.newTermin.data_make) {
        this.showToast('error', 'Błąd', 'Podaj datę dla nowego terminu.');
        return;
      }
      if (!this.newTermin.termin_id) {
        this.showToast('error', 'Błąd', 'Wybierz rodzaj nowego terminu.');
        return;
      }
      const user_id = this.userID;
      let dataEndValue = this.newTermin.data_end;
      if (dataEndValue === 'bezterminowo' || dataEndValue === '') {
        dataEndValue = null;
      }
      console.log('this.lokalnestanowisko', this.lokalnestanowisko);
      try {
        const response = await axios.post(route('bhp.add.termin', user_id), {
          data_make: this.newTermin.data_make,
          data_end: dataEndValue,
          termin_id: this.newTermin.termin_id,
          ile_wczesniej: this.newTermin.ile_wczesniej,
          stanowisko: this.newTermin.stanowisko,
        });

        this.isModalOpenAddTermin = false;
        this.newTermin = this.getEmptyFormTerminy();

        this.fetchTerminy();
        this.showToast('success', 'Dodano', 'Termin został dodany.');
      } catch (err) {
        console.error(err);
        this.showToast('error', 'Błąd', 'Nie udało się dodać terminu.');
      }
    },


    startEditing(date) {
      this.editingDate = date;
      this.editedDate = date;
    },

    startEditingTermin(index, dataMake, dataEnd, ileWczesniej) {
      this.editedDateMake = dataMake || '';
      this.editedDateEnd = dataEnd || '';
      this.editedIleWczesniej = ileWczesniej ?? '';
    },

    setDefaultIleWczesniej() {
      if (this.newTermin.ile_wczesniej === null || this.newTermin.ile_wczesniej === undefined || this.newTermin.ile_wczesniej === '') {
        const selected = this.lokalneTerminy.find(t => t.id === this.newTermin.termin_id);
        this.newTermin.ile_wczesniej = selected ? selected.ile_wczesniej : 0;
      }
    },
    async UpdatedTermin(index) {
      const termin = this.lokalneTerminyUser[index];
      if (!termin) return;

      const newFormattedMake = typeof this.editedDateMake === 'string'
          ? this.editedDateMake
          : new Date(this.editedDateMake).toISOString().split('T')[0];

      const newFormattedEnd = typeof this.editedDateEnd === 'string'
          ? this.editedDateEnd
          : new Date(this.editedDateEnd).toISOString().split('T')[0]

      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Edycja terminu',
        html: 'Czy na pewno chcesz zmienić dane terminu?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        position: 'center',
        timer: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const user_id = this.userID;
          axios.put(route('bhp.update.termin', user_id), {
            newMake: newFormattedMake,
            newEnd: newFormattedEnd,
            termin_id: termin.id,
            ile_wczesniej: this.editedIleWczesniej,
          })
              .then(() => {
                Toast.fire({icon: 'success', title: 'Dane terminu zostały zmienione'});

                this.$set(this.lokalneTerminyUser[index], 'data_make', newFormattedMake);
                this.$set(this.lokalneTerminyUser[index], 'data_end', newFormattedEnd);
                this.$set(this.lokalneTerminyUser[index], 'ile_wczesniej', this.editedIleWczesniej);

                this.editedDateMake = '';
                this.editedDateEnd = '';
                this.editedIleWczesniej = null;
              })
              .catch(error => {
                console.error(error);
                Toast.fire({
                  icon: 'error',
                  title: 'Nie udało się zmienić danych terminu',
                  text: error.response?.data?.message || 'Wystąpił błąd podczas zmiany danych',
                });
              });
        }
      });
    },

    async deleteTermin(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usunięcie terminu',
        html: 'Czy na pewno chcesz usunąć ten termin?',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        position: 'center',
        timer: false,
      }).then((result) => {
        if (result.isConfirmed) {
          const user_id = this.userID;
          axios.delete(route('bhp.del.termin', user_id), {
            data: {termin_id: id} // DELETE z payload
          })
              .then(() => {
                Toast.fire({icon: 'success', title: 'Termin został usunięty'});

                const index = this.lokalneTerminyUser.findIndex(t => t.id === id);
                if (index !== -1) {
                  this.lokalneTerminyUser.splice(index, 1);
                }
              })
              .catch(error => {
                console.error(error);
                Toast.fire({
                  icon: 'error',
                  title: 'Nie udało się usunąć terminu',
                  text: error.response?.data?.message || 'Wystąpił błąd podczas usuwania terminu',
                });
              });
        }
      });
    },

    fetchTerminy() {
      const user_id = this.userID;
      axios.get(route('bhp.get.user.terminy'), {params: {user_id}})
          .then(response => {
            this.lokalneTerminy = response.data.terminy;
            this.lokalneTerminyUser = response.data.terminyUser;
          })
          .catch(error => {
            console.error("Błąd podczas pobierania terminów pracownika:", error);
          });
    },
    getEmptyFormTerminy() {
      return {
        termin_id: '',
        opis: '',
        data_make: '',
        data_end: '',
        ile_wczesniej: null,
        stanowisko: this.lokalnestanowisko ?? ''
      };
    },
    addTermin() {
      this.dodajTermin = true;
      this.newTermin = this.getEmptyFormTerminy();
    },
    cancelNewTermin() {
      this.dodajTermin = false;
      this.newTermin = this.getEmptyFormTerminy();
    },

    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 1500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};
</script>
<style scoped>
.card-title {
  font-weight: bold;
}

.list-group-item.bg-light > div {
  font-size: 0.9rem;
}
</style>